const PictViewClass = require('pict-view');

class LIMSLocationRecordView extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('../LIMS-Application-Web').LIMSPict} */
		this.pict;

		this.AppData.LocationDetails = {};
		this.ActiveLocationLogs = [];
		this.LIMSLocationRecordBackTo = null;
		this.manifest = require('./defaultLocationViewManifest.json');
	}

	async onBeforeRenderAsync(pCallback, pRenderable)
	{
		this.AppData.LocationDetails = {};
		const session = await this.pict.providers.SessionProvider.getSession();
		this.pict.PictApplication.changeTheme('Read');
		if (!this.initialized || (session.CustomerID !== this.customer))
		{
			this.customer = session.CustomerID;
			// Check for a manifest from the DB before loading the default.
			const remoteManifest = await this.pict.ManifestPackagingService.loadRecordManifestSchema('Location', 'View', this.pict.PictApplication.options.pict_configuration.Product);
			this.manifest = remoteManifest || this.manifest;
			this.pict.views.PictFormMetacontroller.clearManifestDescription();
			this.pict.views.PictFormMetacontroller.bootstrapPictFormViewsFromManifest(this.manifest);
			this.pict.views['PictSectionForm-LocationView'].viewMarshalDestination = 'AppData';
			this.pict.views['PictSectionForm-LocationView'].options.DefaultDestinationAddress = '#LIMSLocationRecordView-View-Container';
			// @ts-ignore
			for (const pickList of this.manifest.PickLists || [])
			{
				this.pict.providers.DynamicMetaLists.rebuildListByHash(pickList.Hash);
			}
			this.pict.views['PictSectionForm-LocationView'].rebuildCustomTemplate();
			this.initialized = true;
		}
		super.onBeforeRenderAsync(async () =>
		{
			try
			{
				this.pict.views['PictSectionForm-LocationView'].rebuildCustomTemplate();
				this.log.info('Location Details view rendered with Active Record', this.AppData.LocationDetails);

				// get the IDLocation from the router parameters
				const tmpGUIDLocation = this.pict.providers.LIMSRouter.currentView.split('/')[1];
				if (tmpGUIDLocation)
				{
					this.log.info('Location Details view opened with GUIDLocation', tmpGUIDLocation);
					// get the Location record by ID
					const tmpRecord = await this.pict.providers.LocationProvider.getLocationByGUID(tmpGUIDLocation);
					if (tmpRecord)
					{
						this.AppData.LocationDetails = tmpRecord;
						this.log.info('Location Details view opened with Location record', this.AppData.LocationDetails);
					}
					else
					{
						this.log.error('Location record not found for ID', tmpGUIDLocation);
					}
				}
			}
			catch (error)
			{
				this.log.error('Error in Location Details onBeforeRenderAsync:', error);
			}
			return pCallback();
		}, pRenderable);
	}

	/**
	 * Open the Location detail view for the selected Location to view the full details
	 * @param {number|string} pIDLocation - The ID of the Location to view
	 * @param {object} pLocationRecord - The Location record to view
	 * @param {string} pOpenTab - The tab to open when the Location detail view is shown
	 * @return {Promise<void>}
	 * @async
	 */
	async showLocationDetailView(pIDLocation, pLocationRecord, pOpenTab = 'Details')
	{
		// if a Location record is passed in, use it, otherwise get the Location record by ID
		if (pLocationRecord)
		{
			this.AppData.LocationDetails = Array.isArray(pLocationRecord) ? pLocationRecord[0] : pLocationRecord;
		}
		else
		{
			const tmpRecord = await this.pict.providers.LocationProvider.getLocationByID(pIDLocation);
			this.AppData.LocationDetails = tmpRecord;
		}
		// render the Location detail view
		await new Promise((resolve, reject)=>
		{
			this.renderAsync(() =>
			{
				this.log.info('Location Details View Rendered with Active Record', this.AppData.LocationDetails);
				resolve();
			});
		});
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered.
	 *
	 * @param {import('pict-view').ErrorCallback} fCallback
	 * @param {import('pict-view').Renderable} pRenderable
	 */
	onAfterRenderAsync(fCallback, pRenderable)
	{
		this.pict.views['PictSectionForm-LocationView'].render();
		this.pict.views['PictSectionForm-LocationView'].marshalToView();

		return super.onAfterRenderAsync(fCallback, pRenderable);
	}

	/**
	 * This method is used to handle the Print button click for building the print view.
	 * @return {void}
	 */
	printQRCodeLabel()
	{
		if (!this.AppData.LocationDetails)
		{
			this.log.error('No active Location to print QR Code for');
			return;
		}
		this.log.info('Printing Location Details');
		this.pict.providers.QRCodeProvider.printDecoratedEntity('Location', this.AppData.LocationDetails.QRCode);
	}

	goToEditView()
	{
		if (!this.AppData.LocationDetails)
		{
			this.log.error('[Location-Record-View] No active Location to edit');
			return;
		}
		this.log.info('[Location-Record-View] Going to Edit Location view for Location GUID:', this.AppData.LocationDetails.GUIDLocation);
		this.pict.providers.LIMSRouter.router.navigate(`/Location/${this.AppData.LocationDetails.GUIDLocation}/Edit`);
	}

	confirmDeleteLocation()
	{
		// prompt a confirmation modal to do the deletion
		this.fable.HeadlightModal.spawnModal({
			title: 'Delete Location',
			modalBodyTemplate: /*html*/`
			<div class="container column is-12">
				<p class="title is-5
				has-text-centered p-2 mb-5">
					<span class="icon">
						<i class="fa fa-fw fa-exclamation-triangle has-text-danger"></i>
					</span>
					<span> Are you sure you want to delete this Location?</span>
				</p>
				<p class="is-6 has-text-centered">This action is irreversible and will permanently delete</p>
				<p class="has-text-centered m-3"><strong>${ this.AppData.LocationDetails.Name }</strong></p>
				<p class="is-6 has-text-centered">Please click button below to confirm deletion or close this modal.</p>
			</div>`,
			modalFooterTemplate: /*html*/`
			<div class="buttons is-right">
				<button class="button is-danger is-soft" type="button" title="Cancel Deletion" onclick="_Pict.fable.services.HeadlightModal.dismissModals()">
					<span class="icon">
						<i class="fas fa-fw fa-times" aria-hidden="true"></i>
					</span>
					<span>Cancel</span>
				</button>
				<button class="button is-danger" type="button" title="Delete Location" onclick="_Pict.views.LIMSLocationRecordView.deleteLocation()">
					<span class="icon">
						<i class="fas fa-fw fa-trash" aria-hidden="true"></i>
					</span>
					<span>Delete Location</span>
				</button>
			</div>`,
			confirmText: 'Delete Location',
			cancelText: 'Cancel',
		});
	}

	deleteLocation()
	{
		if (!this.AppData.LocationDetails)
		{
			this.log.error('[Location-Record-View] No active Location to delete');
			return;
		}
		this.log.info('[Location-Record-View] Deleting Location ID:', this.AppData.LocationDetails.IDLocation);
		this.pict.HeadlightRestClient.deleteEntity('Location', this.AppData.LocationDetails.IDLocation, () =>
		{});
		this.pict.providers.LIMSRouter.router.navigate('/PSRS/Location/List');
		this.pict.fable.services.HeadlightModal.dismissModals();
	}

	toggleTabContent(event, pTabID)
	{
		// clear the active class from all tabs
		const tmpTabs = document.querySelectorAll('.tabs ul li');
		tmpTabs.forEach((tab) =>
		{
			tab.classList.remove('is-active');
		});
		// set the active class on the selected tab
		const tmpActiveTab = event.currentTarget;
		if (tmpActiveTab)
		{
			tmpActiveTab?.parentElement.classList.add('is-active');
		}
		// hide all the tab content
		const tmpTabContent = document.querySelectorAll('.tab-content');
		tmpTabContent.forEach((content) =>
		{
			content.classList.remove('is-active');
		});
		// show the selected tab content
		const tmpActiveTabContent = document.getElementById(`${pTabID}-Content`);
		if (tmpActiveTabContent)
		{
			tmpActiveTabContent.classList.add('is-active');
		}
	}
}

module.exports = LIMSLocationRecordView;

module.exports.default_configuration =
{
	ViewIdentifier: 'LIMSLocationRecordView',
	DefaultRenderable: 'LIMSLocationRecordView',
	DefaultDestinationAddress: '#LIMS-Application-Container',
	CSS: /*css*/`
		.tab-content {
			display: none;
		}
		.tab-content.is-active {
			display: block;
		}`,
	Templates:
	[
		{
			Hash: 'LIMSLocationRecordView-Wrapper',
			Template: /*html*/`
			<form class="container form" data-location-id="{~D:Record.IDLocation~}">
				{~T:LIMSLocationRecordView-LocationHeader:AppData.LocationDetails~}
				<!-- Location Panel Tabs -->
				{~T:LIMSLocationRecordView-Panel-Tabs:AppData.LocationDetails~}
				<!-- LIMSLocationRecord Content > Tab Details View -->
				<div id="LIMSLocationRecordViewPanel-Details-Content" class="tab-content is-active">
					<div id="LIMSLocationRecordView-Details-Container">{~T:LIMSLocationRecordView-Tab-Details:AppData.LocationDetails~}</div>
				</div>
			</form>`,
		},
		{
			Hash: 'LIMSLocationRecordView-Panel-Tabs',
			Template: /*html*/`
			<nav class="tabs is-right mt-2">	
				<ul>				
					<li class="is-active">
						<a id="LIMSLocationRecordViewPanel-Details-Tab" class="is-active" onclick="_Pict.views.LIMSLocationRecordView.toggleTabContent(event, 'LIMSLocationRecordPanel-Details')">
							<span class="icon">
								<i class="fa fa-fw fa-info-circle"></i>
							</span>
							<span class="icon-text">
								Details
							</span>
						</a>
					</li>
					<li>
						<a id="LIMSLocationRecordViewPanel-Print-Tab" onclick="_Pict.views.LIMSLocationRecordView.printQRCodeLabel()">
							<span class="icon">
								<i class="fa fa-fw fa-qrcode"></i>
							</span>
							<span class="icon-text">
								Print
							</span>
						</a>
					</li>
				</ul>
			</nav>`,
		},
		{
			Hash: 'LIMSLocationRecordView-LocationHeader',
			Template: /*html*/`
			<div class="container columns has-background-text-soft is-mobile is-vcentered mb-0" style="min-height: 130px">
				<div class="column px-5">
					<p class="title is-4">
						{~TIfAbs:LIMSLocationRecordView-DatumValue-Name:Record:Record.Name^>^0~}
						{~TIfAbs:LIMSLocationRecordView-DatumValue-Name-Empty:Record:Record.Name^<=^0~}
					</p>
					<p class="subtitle is-6 has-text-text-50 mb-2">
						<span class="icon">
							<i class="fas fa-fw fa-qrcode fa-sm"></i>
						</span>
						<span class="icon-text">{~D:Record.QRCode~}</span>
					</p>
				</div>
				<div class="column is-3" style="flex-basis: content;">
					<figure class="image is-96x96 mr-1">{~QRCodeImage:Record.QRCode^96x96^Location^~}</figure>
				</div>
			</div>`,
		},
		{
			Hash: 'LIMSLocationRecordView-Tab-Details',
			Template: /*html*/`
			<!-- Placeholder for dynamic section -->
			<div id="LIMSLocationRecordView-View-Container" class="app-page-gutters-for-mobile px-5 mt-2"></div>
			{~T:LIMSLocationRecordView-Tab-Details-Buttons-Read:AppData.LocationDetails~}`,
		},
		{
			Hash: 'LIMSLocationRecordView-Tab-Details-Buttons-Read',
			Template: /*html*/`
			<div class="buttons my-2 mr-6 is-right">
				<!-- Delete Location Button -->
				<button type="button" id="LIMSLocationRecordViewPanel-Details-Delete-Button" class="button is-link is-outlined" onclick="_Pict.views.LIMSLocationRecordView.confirmDeleteLocation()">
					<span class="icon">
						<i class="fa fa-fw fa-trash"></i>
					</span>
					<span class="icon-text">Delete Location</span>
				</button>
				<!-- Edit Location Button -->
				<button type="button" id="LIMSLocationRecordViewPanel-Logs-Add-Button" class="button is-link" onclick="_Pict.views.LIMSLocationRecordView.goToEditView()">
					<span class="icon">
						<i class="fa fa-fw fa-pencil"></i>
					</span>
					<span class="icon-text">Edit Location</span>
				</button>
			</div>`,
		},
		{
			Hash: 'LIMSLocationRecordView-EntityValue-NA',
			Template: /*html*/`<span class="has-text-text-50">N/A</span>`,
		},
		{
			Hash: 'LIMSLocationRecordView-DatumValue',
			Template: /*html*/`<span class="has-text-text-50">N/A</span>`,
		},
		{
			Hash: 'LIMSLocationRecordView-DatumValue-NA',
			Template: /*html*/`<span class="has-text-text-50">N/A</span>`,
		},
		{
			Hash: 'LIMSLocationRecordView-DatumValue-Name',
			Template: /*html*/`{~D:Record.Name~}`,
		},
		{
			Hash: 'LIMSLocationRecordView-DatumValue-Name-Empty',
			Template: /*html*/`Unnamed Location #{~D:Record.IDLocation~}`,
		},
		{
			Hash: 'LIMSLocationRecordView-DatumValue-Description',
			Template: /*html*/`{~D:Record.Description~}`,
		},
		{
			Hash: 'LIMSLocationRecordView-DatumValue-ParentLocation',
			Template: /*html*/`{~D:Record.ParentLocation.Name~}`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'LIMSLocationRecordView',
			TemplateHash: 'LIMSLocationRecordView-Wrapper',
			DestinationAddress: '#LIMS-Application-Container',
			RenderType: 'replace',
		},
	],
};
